import './DesktopApp.css';
import {useEffect, useRef, useState} from "react";
import Svg from "../Components/SvgClock/Svg";
import Registration from "../Pages/Registration/Registration";
import CortsChoice from "../Components/CortsChoice/CortsChoice";
import ChooseCorts from "../Pages/ChooseCorts/ChooseCorts";
import DesktopLogin from "./DesktopLogin/DesktopLogin";
import {Navigate, Route, Routes, useNavigate} from "react-router-dom";
import {ProtectedRoute} from "../Components/RequireAuth/RequireAuth";
import DesktopRegister from "./DesktopRegister/DesktopRegister";
import Profile from "../Pages/Profile/Profile";
import UserNotifications from "../Pages/UserNotifications/UserNotifications";
import Login from "../Pages/Login/Login";
import axios from "axios";
import Admin from "../Pages/Admin/Admin";
import AdminUsers from "../Pages/Admin/AdminUsers/AdminUsers";
import AdminUserProfile from "../Pages/Admin/AdminUserProfile/AdminUserProfile";
import UserAccount from "../Pages/UserAccount/UserAccount";


function DesktopApp() {

    const navigate = useNavigate();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        axios.get(`/api/is_admin/`, {headers: {
                'Content-Type': 'application/json',
            }, withCredentials: true})
            .then(res => {
                if (res.data.detail) {
                    setIsAdmin(true);
                }
            })
            .catch(e => {
                console.log(e);
                if (e.status === 401) {
                    navigate('/login');
                }
            })
    })

    return (
        <div className={'desktop-app-container'}>

            { isAdmin ? (

                <Routes>
                    <Route path="/">
                        <Route index element={ <ProtectedRoute><Admin /></ProtectedRoute> } />
                        <Route path="admin" element={ <Admin /> } />
                        <Route path="admin_user_search" element={ <AdminUsers /> } />
                        <Route path="admin_user_profile" element={ <AdminUserProfile /> } />
                        <Route path="*" element={ <Navigate to='admin' /> } />
                    </Route>
                </Routes>

            ) : (

                <Routes>
                    <Route path="/">
                        <Route index element={ <ProtectedRoute><Profile /></ProtectedRoute> } />
                        <Route path="reserve/" element={ <ProtectedRoute><ChooseCorts /></ProtectedRoute> } />
                        {/*<Route path="register" element={ <DesktopRegister /> } />*/}
                        <Route path="profile" element={ <Profile /> } />
                        <Route path="account" element={ <UserAccount /> } />
                        {/*<Route path="notifications" element={ <UserNotifications /> } />*/}
                        {/*<Route path="/api/auth/yandex/login/" />*/}
                        {/*<Route path="/api/auth/vk/login/" />*/}
                        <Route path="*" element={ <Navigate to='profile' /> } />
                        {/*<Route path="logout" element={ <Logout /> } />*/}
                    </Route>
                </Routes>

                )}
        </div>
    );
}

export default DesktopApp;
